// extracted by mini-css-extract-plugin
module.exports = {"botao":"BotaoTabela_botao__3hB3V","ativo":"BotaoTabela_ativo__2V-W-","tooltip":"BotaoTabela_tooltip__3bkKP"};